import styled from "styled-components";
import * as common from "../../common";

export const wrapper = styled(common.flexRow)`
  width: 100%;
`;
